var _rect, _rect2, _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImagesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 400",
    style: {
      background: "#f0f0f0"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 125,
    width: 200,
    height: 150,
    rx: 10,
    ry: 10,
    fill: "#cccccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 175,
    r: 15,
    fill: "#ffffff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "320,245 340,205 370,235 390,215 410,245",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImagesvg);
export default __webpack_public_path__ + "static/media/defaultImagesvg.e6612bdda38e8ecb5f87bf73f2795aa9.svg";
export { ForwardRef as ReactComponent };